import React from "react";
import { Card, Box, CardContent, Typography, Button } from "@mui/material";

export const ProductCard: React.FC<{ name: string, highlighted?: boolean, initialFee?: string|number, monthlyFee?: string|number, image?: string, showBuyButton?: boolean, currencyCode?: string, onClick?: () => void, onBuyClick?: () => void }> = ({ name, initialFee, monthlyFee, image, showBuyButton, highlighted, currencyCode, onClick, onBuyClick }) => {
  return (
    <Card sx={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      p: 2, 
      cursor: 'pointer',
      transition: 'all 0.3s ease-in-out',
      ...(highlighted ? {
        boxShadow: '0 5px 15px rgba(0,0,0,0.1), 0 4px 6px rgba(0,0,0,0.08)',
        borderStyle: 'inset',
        borderWidth: '1px',
        borderColor: 'rgb(0, 29, 61)',
      } : {
        '&:hover': {
          boxShadow: '0 5px 15px rgba(0,0,0,0.1), 0 4px 6px rgba(0,0,0,0.08)',
          borderStyle: 'inset',
          borderWidth: '1px',
          borderColor: 'rgb(0, 29, 61)',
        },
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)', 
      })
    }} onClick={onClick}>
      {image && <Box sx={{ bgcolor: '#f5f5f5', py: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <Box component="img" src={image} alt={name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </Box>}
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2, pt: 1.5, pb: 1, paddingLeft: '0px !important', paddingRight: '0px !important' }}>
        <Typography variant="body2" color="text.secondary" gutterBottom sx={{ textAlign: 'center' }}>
          {name.split(' ')[0]}
        </Typography>
        <Typography variant="h6" component="div" gutterBottom fontWeight="bold" sx={{ mb: 1, textAlign: 'center' }}>
          {name}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ flexShrink: 0 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, textAlign: 'center' }}>
              Initial Fee
            </Typography>
            <Typography variant="body1" fontWeight="bold" sx={{ mb: 1, textAlign: 'center' }}>
              {initialFee !== undefined && initialFee !== null
                ? `BD ${parseFloat(String(initialFee)).toFixed(2)}`
                : 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ flexShrink: 0 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, textAlign: 'center' }}>
              Monthly Fee
            </Typography>
            <Typography variant="body1" fontWeight="bold" sx={{ mb: 1, textAlign: 'center' }}>
              {monthlyFee !== undefined && monthlyFee !== null
                ? `${currencyCode || 'USD'} ${parseFloat(String(monthlyFee)).toFixed(2)}/mo`
                : 'N/A'}
            </Typography>
          </Box>
        </Box>
      </CardContent>
      {showBuyButton && <Button 
        variant="contained" 
        onClick={onBuyClick}
        fullWidth 
        sx={{ 
          mt: 'auto',
          borderRadius: '5px',  // Changed from 0 to '20px' for rounded corners
          py: 1.5,
          fontWeight: 'bold'
        }}
      >
        BUY NOW
      </Button>}
    </Card>
  );
};

export default ProductCard;